/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Map_View_3dInputs */

const en_ui_map_view_3d = /** @type {(inputs: Ui_Map_View_3dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3D`)
};

const de_ui_map_view_3d = /** @type {(inputs: Ui_Map_View_3dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3D`)
};

/**
* | output |
* | --- |
* | "3D" |
*
* @param {Ui_Map_View_3dInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_map_view_3d = /** @type {((inputs?: Ui_Map_View_3dInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Map_View_3dInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_map_view_3d(inputs)
	return de_ui_map_view_3d(inputs)
});